import React from "react";
import { Text, View, SafeAreaView, Dimensions, ScrollView, Linking, TouchableOpacity, Platform } from "react-native";
import { useTheme } from './ThemeContext';

const { width: screenWidth, height: screenHeight } = Dimensions.get("window");
const isSmallScreen = screenWidth < 375;
const isLargeScreen = screenWidth >= 390;
const scaleFactor = isSmallScreen ? 0.85 : (isLargeScreen ? 1.0 : 0.95);

export default function Privacy() {
  const { themeValues } = useTheme();

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: themeValues.background,
      }}
    >
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: themeValues.background,
        }}
        contentContainerStyle={{
          flexGrow: 1,
          padding: 20 * scaleFactor,
          paddingTop: Platform.OS === 'ios' ? (isLargeScreen ? 120 : 100) : 60,
        }}
      >
        <View
          style={{
            transform: [{ scale: scaleFactor }]
          }}
        >
          <Text
            style={{
              color: themeValues.primary,
              fontSize: (Platform.OS === 'web' ? 36 : 20) * scaleFactor,
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: 20,
            }}
          >
            Privacy Policy
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 18 : 14) * scaleFactor,
              textAlign: "center",
              lineHeight: (Platform.OS === 'web' ? 24 : 20) * scaleFactor,
              marginBottom: 15,
              fontWeight: "bold",
            }}
          >
            Last Updated: March 29, 2026
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 16 : 14) * scaleFactor,
              lineHeight: (Platform.OS === 'web' ? 22 : 18) * scaleFactor,
              marginBottom: 20,
            }}
          >
            MeditRate is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our meditation app.
          </Text>

          <Text
            style={{
              color: themeValues.primary,
              fontSize: (Platform.OS === 'web' ? 18 : 16) * scaleFactor,
              fontWeight: "bold",
              marginBottom: 10,
            }}
          >
            Information We Collect
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 16 : 14) * scaleFactor,
              lineHeight: (Platform.OS === 'web' ? 22 : 18) * scaleFactor,
              marginBottom: 15,
              fontWeight: "bold",
            }}
          >
            Information We Don't Collect:
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 16 : 14) * scaleFactor,
              lineHeight: (Platform.OS === 'web' ? 22 : 18) * scaleFactor,
              marginBottom: 20,
            }}
          >
            • No Personal Information: We do not collect, store, or transmit any personally identifiable information
            {"\n"}• No Account Required: You can use MeditRate without creating an account
            {"\n"}• No Email or Phone Numbers: We don't ask for or store your contact information
            {"\n"}• No Location Data: We do not access or store your location information
            {"\n"}• No Analytics: We do not use analytics services to track your usage
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 16 : 14) * scaleFactor,
              lineHeight: (Platform.OS === 'web' ? 22 : 18) * scaleFactor,
              marginBottom: 20,
            }}
          >
            <Text style={{ fontWeight: "bold", color: themeValues.text }}>Information We Do Collect:</Text>
            {"\n"}• App Settings: Your meditation preferences are stored locally on your device only
            {"\n"}• Usage Data: Basic app usage information stored locally for app functionality
            {"\n"}• Device Information: Basic device type for compatibility purposes (stored locally)
          </Text>

          <Text
            style={{
              color: themeValues.primary,
              fontSize: (Platform.OS === 'web' ? 18 : 16) * scaleFactor,
              fontWeight: "bold",
              marginBottom: 10,
            }}
          >
            How We Use Your Information
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 16 : 14) * scaleFactor,
              lineHeight: (Platform.OS === 'web' ? 22 : 18) * scaleFactor,
              marginBottom: 20,
            }}
          >
            • Local Storage Only: All information is stored locally on your device and never transmitted to our servers
            {"\n"}• App Functionality: Settings are used only to provide and improve your meditation experience
            {"\n"}• No Third-Party Sharing: We do not share your information with third parties
          </Text>

          <Text
            style={{
              color: themeValues.primary,
              fontSize: (Platform.OS === 'web' ? 18 : 16) * scaleFactor,
              fontWeight: "bold",
              marginBottom: 10,
            }}
          >
            Data Security
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 16 : 14) * scaleFactor,
              lineHeight: (Platform.OS === 'web' ? 22 : 18) * scaleFactor,
              marginBottom: 20,
            }}
          >
            • Local Storage: Your data remains on your device and is not transmitted over the internet
            {"\n"}• No Server Storage: We do not maintain servers that store your personal information
            {"\n"}• Device Security: Your data is protected by your device's built-in security features
          </Text>

          <Text
            style={{
              color: themeValues.primary,
              fontSize: (Platform.OS === 'web' ? 18 : 16) * scaleFactor,
              fontWeight: "bold",
              marginBottom: 10,
            }}
          >
            Children's Privacy
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 16 : 14) * scaleFactor,
              lineHeight: (Platform.OS === 'web' ? 22 : 18) * scaleFactor,
              marginBottom: 20,
            }}
          >
            MeditRate does not knowingly collect any personal information from children under 13. If you believe we have inadvertently collected such information, please contact us immediately.
          </Text>

          <Text
            style={{
              color: themeValues.primary,
              fontSize: (Platform.OS === 'web' ? 18 : 16) * scaleFactor,
              fontWeight: "bold",
              marginBottom: 10,
            }}
          >
            Contact Us
          </Text>

          <Text
            style={{
              color: themeValues.text,
              fontSize: (Platform.OS === 'web' ? 16 : 14) * scaleFactor,
              lineHeight: (Platform.OS === 'web' ? 22 : 18) * scaleFactor,
              marginBottom: 20,
            }}
          >
            If you have questions about this Privacy Policy, please contact us:
            {"\n"}• Email: meditrateapp@gmail.com
            {"\n"}• Website: https://www.meditrate.com
          </Text>

          <TouchableOpacity
            style={{ marginTop: 20, marginBottom: 30 }}
            onPress={() => Linking.openURL('mailto:meditrateapp@gmail.com')}
          >
            <Text
              style={{
                color: themeValues.primary,
                fontSize: Platform.OS === 'web' ? 18 : 16,
                textAlign: "center",
                textDecorationLine: "underline",
              }}
            >
              Contact Privacy Support
            </Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}
